import axios from 'axios';
import store from '@/store';

axios.defaults.showLoader = false;
axios.defaults.refreshToken = false;

export default function setup() {
  axios.interceptors.request.use((request) => {
    const accessToken = store.getters['authentication/getAccessToken'];

    if (accessToken) {
      /* eslint-disable no-param-reassign */
      request.headers.Authorization = `Bearer ${accessToken}`;
    }

    return request;
  });

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response ? error.response.status : null;

      if (status >= 400) {
        if (status === 401) {
          return store.dispatch('authentication/authenticateWithRefreshToken', () => {
            /* eslint-disable no-param-reassign */
            error.config.headers.Authorization = `Bearer ${store.getters['authentication/getAccessToken']}`;
            return axios.request(error.config);
          });
        }
      }

      return Promise.reject(error);
    },
  );
}
